import { getBookingsRelativeUrl, getSectionRelativeUrl, getUrlQueryParams, queryBuilder, isBookingsSectionInstalled, BOOKINGS_SERVICE_PAGE_SECTION_ID } from '@wix/bookings-catalog-calendar-viewer-utils';
async function getServicePageRelativeUrl(wixCodeApi) {
  if (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID)) {
    return getSectionRelativeUrl(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID);
  }
  return getBookingsRelativeUrl(wixCodeApi);
}
export async function navigateToBookingsServicePage(wixCodeApi, _ref) {
  let {
    serviceSlug,
    referral,
    location
  } = _ref;
  const suffix = `${serviceSlug}`;
  const query = queryBuilder({
    ...getUrlQueryParams(wixCodeApi),
    ...{
      referral,
      location
    }
  });
  const servicePageRelativeUrl = await getServicePageRelativeUrl(wixCodeApi);
  wixCodeApi.location.to(`${servicePageRelativeUrl}/${suffix + query}`);
}
//# sourceMappingURL=navigateToBookingsServicePage.js.map